// extracted by mini-css-extract-plugin
export default {"card":"square-card_card__jEze2"};